import './state/legacyStorage';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import './styles/base.css';
import { App } from './app/App';
import { isDemoPath } from './app/router';
import { liveBackend, type Backend } from './net/backend';
import { registerServiceWorker } from './pwa/push';
import { watchForUpdates } from './pwa/update';
import { applySettingsToDocument, useSettings } from './state/settingsStore';

async function start() {
  applySettingsToDocument(useSettings.getState());
  // Demo mode (`/demo/*`) runs the whole UI offline against fixtures; load it only when needed.
  let backend: Backend = liveBackend;
  if (isDemoPath()) {
    const { createDemoBackend } = await import('./dev/demoBackend');
    backend = createDemoBackend();
  }
  const root = document.getElementById('root');
  if (!root) return;
  createRoot(root).render(
    <StrictMode>
      <App backend={backend} />
    </StrictMode>,
  );
}

void start();

// Offline shell + push. Registered after load so it never competes with first paint.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener(
    'load',
    () =>
      void registerServiceWorker().then((registration) => {
        if (registration) watchForUpdates(registration);
      }),
    { once: true },
  );
}
